import { createContext } from 'react'

export const WelcomeContext = createContext({})
